import { ListReports } from "../../../fragments/admin/custom-reports/ListReports"

const CustomReports = () => {
    return (
        <main>
            <ListReports />
        </main>
    )
}

export default CustomReports
